import Script from 'next/script';

import ComponentPlaceholder from 'components/ComponentPlaceholder';
import { LayoutContainer } from 'components/Layout';
import { useEffectOnce } from 'hooks';
import type { Field, SitecoreBlockProps, SitecoreLink } from 'models/sitecore';
import { getEditorMargin } from 'utils/business-logic';

interface Props extends SitecoreBlockProps {
	fields?: {
		link: Field<SitecoreLink>;
	};
}

export default function TrustvoiceAllReviews({ fields, params }: Props) {
	// For when a user returns to a page with this component and the script
	// has already been loaded (no onLoad callback runs).
	useEffectOnce(() => {
		if (globalThis.testFreaks) {
			globalThis.testFreaks.push(['load', ['all-reviews']]);
		}
	});

	if (!fields) {
		return null;
	}

	if (!fields.link.value.href) {
		return (
			<ComponentPlaceholder
				className={getEditorMargin(params)}
				componentName="TrustvoiceAllReviews"
				description="Requires a link"
			/>
		);
	}

	return (
		<>
			<LayoutContainer outerClassName={getEditorMargin(params)}>
				<div id="testfreaks-all-reviews" />
			</LayoutContainer>
			<Script
				src={fields?.link.value.href}
				id="testfreaks-all-reviews-js-embed"
				strategy="afterInteractive"
				onLoad={() => {
					globalThis.testFreaks ??= [];
					globalThis.testFreaks.push(['load', ['all-reviews']]);
				}}
			/>
		</>
	);
}
TrustvoiceAllReviews.displayName = 'TrustvoiceAllReviews';
